module.exports = __webpack_public_path__ + "static/img/banner01.60eaa46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/banner01.png
// module id = 1c0a
// module chunks = 1